import { makeAutoObservable } from "mobx";

class SearchStore {
  query = "";
  status = "";

  constructor() {
    makeAutoObservable(this);
  }

  setQuery(value: string) {
    this.query = value;
  }

  setStatus(value: string) {
    this.status = value;
  }

  clear() {
    this.query = "";
  }
}

const searchStore = new SearchStore();
export default searchStore;
